import React, { useState } from 'react';
import { Play, Pause, Info } from 'lucide-react';

interface GameControlsProps {
    isPlaying: boolean;
    onPlayPause: () => void;
}

const GameControls: React.FC<GameControlsProps> = ({ isPlaying, onPlayPause }) => {
    const [showInstructions, setShowInstructions] = useState(false);

    const toggleInstructions = () => {
        setShowInstructions(!showInstructions);
    };

    return (
        <>
            <div className="fixed top-6 left-6 z-50">
                <div className="bg-slate-800/90 rounded-full p-2 flex items-center gap-2 backdrop-blur-sm">
                    <button
                        onClick={onPlayPause}
                        className="h-10 w-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                        aria-label={isPlaying ? "Pause" : "Play"}
                    >
                        {isPlaying ? (
                            <Pause className="h-5 w-5 text-white" />
                        ) : (
                            <Play className="h-5 w-5 text-white" />
                        )}
                    </button>

                    {/* Instructions Button */}
                    <button
                        onClick={toggleInstructions}
                        className="h-10 w-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                        aria-label="Instructions"
                    >
                        <Info className="h-5 w-5 text-white" />
                    </button>
                </div>
            </div>

            {/* Instructions Modal */}
            {showInstructions && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="max-w-md w-full mx-4">
                        <div className="bg-white p-6 rounded-lg shadow-xl border border-gray-200">
                            <div className="flex items-start">
                                <div className="flex-1">
                                    <h3 className="text-xl font-bold text-gray-900">
                                        How to Play
                                    </h3>
                                    <div className="mt-4 text-gray-600">
                                        <p className="mb-2">1. Click one of the letters to start the falling icons</p>
                                        <p className="mb-2">2. Click the icons as they fall the guess the correct one</p>
                                        <p className="mb-2">3. A Lion running represents correct and a scratch represents wrong</p>
                                        <button
                                            onClick={toggleInstructions}
                                            className="mt-4 px-4 py-2 bg-slate-800 text-white rounded-md hover:bg-slate-700 transition-colors"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default GameControls;